import React from 'react'
import PropTypes from 'prop-types'

// styles
import style from '@aytm/app/stats/page/sidebar/reports/styles/ReportPopup.module.scss'

const APPLIED_FILTERS_EMPTY = 'None'

// Read-only rows for the report-popup description column, used for both the applied
// filters and the customizations. Each row renders its title and, when present, its HTML
// value. Rendered as the body of a ReportPopupSection, which is offered on every report -
// a report nobody has filtered reads its own emptiness rather than losing the section.
const ReportPopupAppliedFilters = ({ filters }) =>
  !filters || 0 === filters.length ? (
    <div className={style['description-content-section-body-content-row']}>{APPLIED_FILTERS_EMPTY}</div>
  ) : (
    <>
      {filters.map((filter, index) =>
        filter.value ? (
          <div key={`filter-${index}`} className={style['description-content-section-body-content-row']}>
            <b>{filter.title}:</b>
            <br />
            <div dangerouslySetInnerHTML={{ __html: filter.value }} />
          </div>
        ) : (
          <div key={`filter-${index}`} className={style['description-content-section-body-content-row']}>
            <b>{filter.title}</b>
          </div>
        )
      )}
    </>
  )

ReportPopupAppliedFilters.propTypes = {
  filters: PropTypes.array
}

ReportPopupAppliedFilters.displayName = 'ReportPopupAppliedFilters'

export default ReportPopupAppliedFilters
